import React from "react";
import "./HomeScreen.css";
import Banner     from "../../../components/Banner/Banner";
import Header     from "../../../components/Header/Header";
import Footer     from "../../../components/Footer/Footer";
import Parlors    from "../../../sections/Parlors/Parlors";
import WhyChooseUs from "../../../sections/whyChooseUs/WhyChooseUs";
import Stats      from "../../../sections/Stats/Stats";
import GlamCTA    from "../../../sections/GlamCTA/GlamCTA";
import GlamCTA2    from "../../../sections/GlamCTA2/GlamCTA";
import FAQ, { FAQS } from "../../../sections/FAQ/FAQ";
import Seo from "../../../components/Seo/Seo";
import { PAGES } from "../../../seo/seo.config";
import { faqSchema } from "../../../seo/structuredData";

// Built once at module scope — the content is static, so there's no reason to
// rebuild the object (and re-run the <Seo /> effect) on every render.
const HOME_JSON_LD = faqSchema(FAQS);

function HomeScreen() {
  return (
    <div>
      <Seo
        title={PAGES.home.title}
        description={PAGES.home.description}
        keywords={PAGES.home.keywords}
        canonical={PAGES.home.path}
        jsonLd={HOME_JSON_LD}
      />
      <Header />
      <Banner />
      <Parlors />
       <GlamCTA />
      <WhyChooseUs />
      {/* <Stats /> */}
     <GlamCTA2 />
      <FAQ />
      <Footer />
    </div>
  );
}

export default HomeScreen;
